export default __webpack_public_path__ + "static/media/GLI_Plan_Brochure.2c5d0dbe.pdf";